


































import Vue from 'vue'
import VueCompositionApi from '@vue/composition-api'
import CommentItem from './comment-item.vue'
import CommentEditor from './comment-editor.vue'
import { CommentListItem } from '../types/comment'
Vue.use(VueCompositionApi)

export default Vue.extend({
  name: 'vue-comment',

  components: {
    CommentItem,
    CommentEditor
  },

  data () {
    return {
      currentReplyContent: ''
    }
  },

  props: {
    user: {
      type: Object
    },
    nums: {
      type: Number
    },
    list: {
      type: Array,
      default () {
        return []
      }
    }
  },

  methods: {
    handleOpt (type: 'reply' | 'edit' | 'del', item: CommentListItem) {
      if (type === 'reply') {
        this.currentReplyContent = item.input
      } else if (type === 'del') {
        this.$emit('del', item)
      }
    },

    handleSubmit (input: string, inputCompiler: string) {
      this.$emit('submit', input, inputCompiler)
    },

    login () {
      if (!this.user) {
        this.$emit('login')
      }
    },

    resetEditor () {
      // @ts-ignore
      this.$refs.editor.resetEditor()
    }
  }
})
